import { Injectable } from '@angular/core';
import { CommonService } from '../../commons/services/common.service';

@Injectable()
export class ConstanteEcorec {
    // Constantes pour les types de formats parametrable
    public static TYPE_FORMAT_PARAMETRABLE_DEVIS = 1;
    public static TYPE_FORMAT_PARAMETRABLE_FACTURE = 2;
    public static TYPE_FORMAT_PARAMETRABLE_AVOIR = 3;
    public static TYPE_FORMAT_PARAMETRABLE_BON_ACHAT = 4;
    public static TYPE_FORMAT_PARAMETRABLE_AVOIR_ACHAT = 5;
    public static TYPE_FORMAT_PARAMETRABLE_BON = 6;
    public static TYPE_FORMAT_PARAMETRABLE_BON_BENNES = 7;
    public static TYPE_FORMAT_PARAMETRABLE_BON_ACHATS_PARTICULIERS = 8;
    public static TYPE_FORMAT_PARAMETRABLE_BON_CAMIONS = 9;
    public static TYPE_FORMAT_PARAMETRABLE_CONTRAT = 10;
    public static TYPE_FORMAT_PARAMETRABLE_FACT_PRO_FORMA = 11;
    public static TYPE_FORMAT_PARAMETRABLE_PLANNING_BENNE = 12;
    public static TYPE_FORMAT_PARAMETRABLE_REMISE_BANQUE = 13;
    public static TYPE_FORMAT_PARAMETRABLE_PAIEMENT_BANQUE = 14;
    public static TYPE_FORMAT_PARAMETRABLE_BON_ECOLOC = 15;
    public static TYPE_FORMAT_PARAMETRABLE_RAPPORT_VISITE = 16;
    public static TYPE_FORMAT_PARAMETRABLE_TICKET_PESEE_BON = 17;
    public static TYPE_FORMAT_PARAMETRABLE_TRAITE = 18;
    public static TYPE_FORMAT_PARAMETRABLE_PLANNING_ECOLOC = 19;
    public static TYPE_FORMAT_PARAMETRABLE_TICKET_PESEE_BON_ACHAT = 20;
    public static TYPE_FORMAT_PARAMETRABLE_TICKET_PESEE_ECOPONT = 21;
    public static TYPE_FORMAT_PARAMETRABLE_TICKET_PESEE_VHU = 22;
    public static TYPE_FORMAT_PARAMETRABLE_RELANCE = 23;
    public static TYPE_FORMAT_PARAMETRABLE_BON_ACHATS_PARTICULIERS_PAR_CHEQUE = 24;
    public static TYPE_FORMAT_PARAMETRABLE_BON_ECOACHAT = 25;
    public static TYPE_FORMAT_PARAMETRABLE_TICKET_PESEE_ECOBADGE = 26;
    public static TYPE_FORMAT_PARAMETRABLE_ATTESTATION_CONFORMITE = 27;
    public static TYPE_FORMAT_PARAMETRABLE_ORDRE_REPARATION = 28;
    public static TYPE_FORMAT_PARAMETRABLE_CERTIFICAT_DESTRUCTION_VALORISATION = 29;
    public static TYPE_FORMAT_PARAMETRABLE_CAP = 30;
    public static TYPE_FORMAT_PARAMETRABLE_ETIQUETTE_ADR = 31;
    public static TYPE_FORMAT_PARAMETRABLE_PROCESSUS_PRODUCTION_PRODUIT = 32;
    public static TYPE_FORMAT_PARAMETRABLE_FICHE_REGROUPEMENT = 33;
    public static TYPE_FORMAT_PARAMETRABLE_RELANCE_DEVIS = 34;
    public static TYPE_FORMAT_PARAMETRABLE_FORMAT_DEPOLLUTION = 35;
    public static TYPE_FORMAT_PARAMETRABLE_DEVIS_CR_DEPOT_CONTENANT = 36;
    public static TYPE_FORMAT_PARAMETRABLE_FIP_DND = 37;
    public static TYPE_FORMAT_PARAMETRABLE_FIP_DD = 38;
    public static TYPE_FORMAT_PARAMETRABLE_BON_ECOBAC = 39;
    public static TYPE_FORMAT_PARAMETRABLE_PLANNING_ECOBAC = 40;
    public static TYPE_FORMAT_PARAMETRABLE_PLANNING_COLLECTE_SELECTIVE = 41;
    public static TYPE_FORMAT_PARAMETRABLE_ADRESSE_ENVOIE_PIECE = 42;
    public static TYPE_FORMAT_PARAMETRABLE_TOURNEE = 43;
    public static TYPE_FORMAT_PARAMETRABLE_RELEVE_RELANCE = 44;
    public static TYPE_FORMAT_PARAMETRABLE_LISTE_CLIENTS_EXP_DASRI = 45;
    public static TYPE_FORMAT_PARAMETRABLE_DOC_DMD_ECOPORTAIL = 46;
    public static TYPE_FORMAT_PARAMETRABLE_BON_PRELEVEMENT = 47;

    public static DROIT_PONT = 0x00400000;
    public static DROIT_PESEE_MANUEL = 0x80000000;

    // Constantes pour les types des infos de pont bascule (table :  typeInfoProtocole)
    public static TYPE_INFO_PONT_BASCULE_DATE = 'DATE';
    public static TYPE_INFO_PONT_BASCULE_HEURE = 'HEURE';
    public static TYPE_INFO_PONT_BASCULE_POIDS = 'POIDS';
    public static TYPE_INFO_PONT_BASCULE_DSD = 'DSD';
    public static TYPE_INFO_PONT_BASCULE_POIDSSEUL = 'POIDSSEUL';

    // Codes des unites
    /**
     * Unite : kilog
     */
    public static UNITE_KG = 1;
    /**
     * Unite : tonne
     */
    public static UNITE_T = 2;
    /**
     * Unite : unite
     */
    public static UNITE_U = 3;
    /**
     * Unite : metre cube
     */
    public static UNITE_MCUBE = 4;
    /**
     * Unite : litre
     */
    public static UNITE_L = 5;
    /**
     * Unite : fut
     */
    public static UNITE_FUT = 6;
    /**
     * Unite : heure
     */
    public static UNITE_H = 7;

    // Constantes pour les clef des tables dans 'tableEcorec'
    public static TABLE_ECOREC_CLIENTS = 1;
    public static TABLE_ECOREC_ACTIVITES = 2;
    public static TABLE_ECOREC_ARTICLES = 3;
    public static TABLE_ECOREC_BASSIN_AGENCE_EAU = 4;
    public static TABLE_ECOREC_BROYEUR = 5;
    public static TABLE_ECOREC_COMPTES = 6;
    public static TABLE_ECOREC_EMPLACEMENT_STOCK = 7;
    public static TABLE_ECOREC_EXUTOIRES = 8;
    public static TABLE_ECOREC_EXUTOIRES_AGENCE_EAU = 9;
    public static TABLE_ECOREC_TYPE_ARTICLE = 10;
    public static TABLE_ECOREC_FILIERE_FACTURATION = 11;
    public static TABLE_ECOREC_FOURNISSEUR = 12;
    public static TABLE_ECOREC_INDICE = 13;
    public static TABLE_ECOREC_BENNES = 14;
    public static TABLE_ECOREC_CAMIONS = 15;
    public static TABLE_ECOREC_CHAUFFEURS = 16;
    public static TABLE_ECOREC_CUBAGES_CONTENANT = 17;
    public static TABLE_ECOREC_EQUIPEMENT_CAMION = 18;
    public static TABLE_ECOREC_FAMILLE_CONTENANT = 19;
    public static TABLE_ECOREC_FAMILLE_FOURNITURE = 20;
    public static TABLE_ECOREC_FOURNITURE = 3;
    public static TABLE_ECOREC_MATERIEL = 21;
    public static TABLE_ECOREC_MECANICIEN = 22;
    public static TABLE_ECOREC_PIECE = 23;
    public static TABLE_ECOREC_PROGRAMME_ENTRETIEN = 24;
    public static TABLE_ECOREC_SOUS_FAMILLE_FOURNITURE = 25;
    public static TABLE_ECOREC_TYPE_EQUIPEMENT = 26;
    public static TABLE_ECOREC_TYPE_EQUIPEMENT_CAMION = 27;
    public static TABLE_ECOREC_TYPE_CAMION = 28;
    public static TABLE_ECOREC_TYPE_CONTENANT = 29;
    public static TABLE_ECOREC_PARKING = 30;
    public static TABLE_ECOREC_RAYON_STOCK = 31;
    public static TABLE_ECOREC_RESSOURCE = 32;
    public static TABLE_ECOREC_SITE = 33;
    public static TABLE_ECOREC_SOCIETE = 34;
    public static TABLE_ECOREC_SOUS_FAMILLE_ARTICLE = 35;
    public static TABLE_ECOREC_TRANSPORTEURS = 36;
    public static TABLE_ECOREC_TVA = 37;
    public static TABLE_ECOREC_UTILISATEURS = 38;
    public static TABLE_ECOREC_FACTURE = 39;
    public static TABLE_ECOREC_BON_ACHAT = 40;
    public static TABLE_ECOREC_AVOIR_ACHAT = 41;
    public static TABLE_ECOREC_AVOIR = 42;
    public static TABLE_ECOREC_BON = 43;
    public static TABLE_ECOREC_COURTIERS = 44;
    public static TABLE_ECOREC_DEVIS = 45;
    public static TABLE_ECOREC_CONTRAT = 46;
    public static TABLE_ECOREC_PRECONTRAT = 47;
    public static TABLE_ECOREC_ACTIVITES_SOCIETE = 48;
    public static TABLE_ECOREC_LOCATION_MATERIEL = 49;
    public static TABLE_ECOREC_DEPLACEMENT_COMMERCIAL = 50;
    public static TABLE_ECOREC_GROUPE_CLIENT = 51;
    public static TABLE_ECOREC_CHAMPS_CLIENT_SUPPL = 52;
    public static TABLE_ECOREC_PAIEMENT = 53;
    public static TABLE_ECOREC_PAIEMENT_ACHAT = 54;
    public static TABLE_ECOREC_FORMAT_PARAMETRABLE = 55;
    public static TABLE_ECOREC_ENTREE_DD = 56;
    public static TABLE_ECOREC_EXPEDITION_DD = 57;
    public static TABLE_ECOREC_BON_ACHAT_PARTICULIER = 58;
    public static TABLE_ECOREC_MOVEMENT_CAISSE = 59;
    public static TABLE_ECOREC_DECONSTRUCTEUR = 60;
    public static TABLE_ECOREC_AGENCE_INTERIM = 61;
    public static TABLE_ECOREC_PONT_BASCULE = 62;
    public static TABLE_ECOREC_PESEE = 63;
    public static TABLE_ECOREC_PROFIL_UTILISATEUR = 64;
    public static TABLE_ECOREC_HISTO_HORAIRE_MOUVEMENT = 65;
    public static TABLE_ECOREC_HISTO_HORAIRE_LOCATION = 66;
    public static TABLE_ECOREC_HISTO_HORAIRE_MANUEL = 67;
    public static TABLE_ECOREC_LIEU_DEPART = 68;
    public static TABLE_ECOREC_HISTO_HORAIRE_LOCATION_BON = 69;
    public static TABLE_ECOREC_FORMAT_PARAM_COMPTA = 70;
    public static TABLE_ECOREC_TRANSFORMATION_PRODUIT = 71;
    public static TABLE_ECOREC_TYPE_PRESTATION_CAMION = 72;
    public static TABLE_ECOREC_INDISPONIBILITE_RAISON = 73;
    public static TABLE_ECOREC_MOTIF_MISSION_INTERIMAIRE = 74;
    public static TABLE_ECOREC_QUALIFICATION_PERSONNEL = 75;
    public static TABLE_ECOREC_TRANSFORMATION_STOCK = 76;
    public static TABLE_ECOREC_SECTION_DEVIS = 77;
    public static TABLE_ECOREC_MOTIF_REFUS = 78;
    public static TABLE_ECOREC_HISTO_HORAIRE_TRANSFORM_STOCK = 79;
    public static TABLE_ECOREC_VHU = 80;
    //Sous type d'equipement
    public static TABLE_ECOREC_SOUS_TYPE_EQUIPEMENT = 81;
    //Type de propriete
    public static TABLE_ECOREC_TYPE_PROPRIETE = 82;
    public static TABLE_ECOREC_PERIODE = 83;
    //Sous type camion
    public static TABLE_ECOREC_SOUS_TYPE_CAMION = 84;
    public static TABLE_ECOREC_PAIEMENT_BON_RECEPTION = 85;
    public static TABLE_ECOREC_GROUPE_IMPRESSION = 86;
    public static TABLE_ECOREC_REMISE_BANQUE = 87;
    public static TABLE_ECOREC_PAIEMENT_BANQUE = 88;
    public static TABLE_ECOREC_TMP = 89;
    public static TABLE_ECOREC_MODULATION_PERSONNEL = 90;
    public static TABLE_ECOREC_INDISPONIBILITE_CHAUFFEUR = 91;
    public static TABLE_ECOREC_INDISPONIBILITE_CAMION = 92;
    public static TABLE_ECOREC_PROCESSUS_PROD = 93;
    public static TABLE_ECOREC_PROCESSUS_PRODUCTION_PRODUIT = 94;
    public static TABLE_ECOREC_REMISE_BANQUE_AVOIR = 95;
    public static TABLE_ECOREC_PAIEMENT_AVOIR = 96;
    public static TABLE_ECOREC_BENNE_CHANTIERS = 97;
    public static TABLE_ECOREC_INTERVENTION_BAC = 98;
    public static TABLE_ECOREC_OPERATION_BAC = 99;
    public static TABLE_ECOREC_HISTO_HORAIRE_POSTE_INTERVENTION_BAC_EQUIPE = 100;
    public static TABLE_ECOREC_TYPE_DEPLACEMENT_COMMERCIAL = 101;
    public static TABLE_ECOREC_MOTIF_DEPLACEMENT_COMMERCIAL = 102;
    public static TABLE_ECOREC_OBJECTIF_DEPLACEMENT_COMMERCIAL = 103;
    public static TABLE_ECOREC_HISTO_HORAIRE_MOUVEMENT_BON = 104;
    public static TABLE_ECOREC_MOTIF_REFUS_FIP = 105;
    public static TABLE_ECOREC_AFFRETEUR = 106;
    public static TABLE_ECOREC_BSDD = 107;
    public static TABLE_ECOREC_CHANTIERS = 108;
    public static TABLE_ECOREC_FAMILLE_ARTICLE = 109;
    public static TABLE_ECOREC_ASSIGNATION_CHAUFFEUR_MISSION_INTERIM = 110;
    public static TABLE_ECOREC_TYPE_TERRITOIRE = 111;
    public static TABLE_ECOREC_DEMANDE_ECOGED = 112;
    public static TABLE_ECOREC_TYPE_DEMANDE_ECOGED = 113;
    public static TABLE_ECOREC_CYCLE_TRAVAIL = 114;
    public static TABLE_ECOREC_DEMANDE_CLIENT_ECOBENNE = 115;
    public static TABLE_ECOREC_PRESTATION_CAMION = 116;

    // Codes des operations sur les bennes
    /**
     * Operation de depot d'une benne
     */
    public static BENNE_DEPOT = 0;
    /**
     * Operation de retrait d'une benne
     */
    public static BENNE_RETRAIT = 1;
    /**
     * Operation de rotation d'une benne
     */
    public static BENNE_ROTATION = 2;
    /**
     * Operation de location d'une benne
     */
    public static BENNE_LOCATION = 3;
    /**
     * Operation de forfait d'une benne
     */
    public static BENNE_FORFAIT = 4;
    /**
     * Operation de suppression d'une benne
     */
    public static BENNE_SUPP = 5;
    /**
     * Autres operation
     */
    public static BENNE_AUTRES = 6;
    /**
     * Operation de location Jour d'une benne
     */
    public static BENNE_LOCATIONJ = 7;

    public static SUCCESS_CODE_SETTING_TABLE = 'SUCCESS';     //Succces
    public static ERROR_CODE_DUPLICATE_KEY_SETTING_TABLE = 'ERR_SETTING_TABLE_0';     //doublon ERR_SETTING_TABLE_0
    public static ERROR_CODE_GENERAL_SETTING_TABLE = 'ERR_RAPPORT_1'; //erreur general    

    /**
     * Article de la famille des dechets
     */
    public static ARTICLE_DECHET = 1;
    /**
     * Article de la famille des prestations
     */
    public static ARTICLE_PRESTATION = 2;
    /**
     * Article de la famille de la matiere
     */
    public static ARTICLE_MATIERE = 3;
    /**
     * Article de la famille des subventions
     */
    public static ARTICLE_SUBV = 4;
    /**
     * Article de la famille des prestations clients
     */
    public static ARTICLE_PREST_CLIENT = 5;
    /**
     * Article de la famille des fournitures
     */
    public static ARTICLE_FOURNITURE = 6;
    /**
     * Article de la famille des transports
     */
    public static ARTICLE_TRANSPORT = 7;
    /**
     * Article de la famille toutes
     */
    public static ARTICLE_TOUS = 8;
    /**
     * Article de la famille commentaire
     */
    public static ARTICLE_COMMENTAIRE = 9;
    /**
     * Article produit fini
     */
    public static ARTICLE_PRODUIT_FINI = 10;

    public static TYPE_CHAMP_FICHE_NOMBRE_REEL = 1;
    public static TYPE_CHAMP_FICHE_CHAINE_CARACTERES = 2;
    public static TYPE_CHAMP_FICHE_BOOLEEN = 3;
    public static TYPE_CHAMP_FICHE_LISTE = 4;

    CHAMP_FICHE_CLIENT_ENSEIGNE = 1;
    CHAMP_FICHE_CLIENT_CIVILITE = 2;
    CHAMP_FICHE_CLIENT_SURNOM = 3;
    CHAMP_FICHE_CLIENT_CODE_PROSPECT = 4;
    CHAMP_FICHE_CLIENT_DATE_CREATION = 5;
    CHAMP_FICHE_CLIENT_TEL = 6;
    CHAMP_FICHE_CLIENT_FAX = 7;
    CHAMP_FICHE_CLIENT_MAIL = 8;
    CHAMP_FICHE_CLIENT_ADRESSE1 = 9;
    CHAMP_FICHE_CLIENT_ADRESSE2 = 10;
    CHAMP_FICHE_CLIENT_ADRESSE3 = 11;
    CHAMP_FICHE_CLIENT_CODE_POSTAL = 12;
    CHAMP_FICHE_CLIENT_VILLE = 13;
    CHAMP_FICHE_CLIENT_PAYS = 14;
    CHAMP_FICHE_CLIENT_NOM_FACT = 15;
    CHAMP_FICHE_CLIENT_ADRESSE1_FACT = 16;
    CHAMP_FICHE_CLIENT_ADRESSE2_FACT = 17;
    CHAMP_FICHE_CLIENT_ADRESSE3_FACT = 18;
    CHAMP_FICHE_CLIENT_CODE_POSTAL_FACT = 19;
    CHAMP_FICHE_CLIENT_VILLE_FACT = 20;
    CHAMP_FICHE_CLIENT_PAYS_FACT = 21;
    CHAMP_FICHE_CLIENT_ACTIVITE = 22;
    CHAMP_FICHE_CLIENT_AUTRE_ACTIVITE = 23;
    CHAMP_FICHE_CLIENT_APE = 24;
    CHAMP_FICHE_CLIENT_SIRET = 25;
    CHAMP_FICHE_CLIENT_TYPE_CLIENT = 26;
    CHAMP_FICHE_CLIENT_RESPONSABLE = 27;
    CHAMP_FICHE_CLIENT_TEL_RESPONSABLE = 28;
    CHAMP_FICHE_CLIENT_MAIL_RESPONSABLE = 29;
    CHAMP_FICHE_CLIENT_FAX_RESPONSABLE = 30;
    CHAMP_FICHE_CLIENT_MAIL_FACT = 31;
    CHAMP_FICHE_CLIENT_PORTABLE_RESPONSABLE = 32;
    CHAMP_FICHE_CLIENT_GARAGE = 33;
    CHAMP_FICHE_CLIENT_PESEL = 34;
    CHAMP_FICHE_CLIENT_ECODECHETTERIE = 35;
    CHAMP_FICHE_CLIENT_LOGIN_RAPPORT = 36;
    CHAMP_FICHE_CLIENT_CHANTIER = 37;
    CHAMP_FICHE_CLIENT_VISIBILITE = 38;
    CHAMP_FICHE_CLIENT_ECOENV = 39;
    CHAMP_FICHE_CLIENT_NOM_ACHAT = 40;
    CHAMP_FICHE_CLIENT_ADRESSE1_ACHAT = 41;
    CHAMP_FICHE_CLIENT_ADRESSE2_ACHAT = 42;
    CHAMP_FICHE_CLIENT_ADRESSE3_ACHAT = 43;
    CHAMP_FICHE_CLIENT_CODE_POSTAL_ACHAT = 44;
    CHAMP_FICHE_CLIENT_VILLE_ACHAT = 45;
    CHAMP_FICHE_CLIENT_PAYS_ACHAT = 46;
    CHAMP_FICHE_CLIENT_LISTE_CONTACT = 47;
    CHAMP_FICHE_CLIENT_STATUT = 48;
    CHAMP_FICHE_CLIENT_EFFECTIF = 49;
    CHAMP_FICHE_CLIENT_POURCENTAGE = 50;
    CHAMP_FICHE_CLIENT_CODE_TVA_INTRA = 51;
    CHAMP_FICHE_CLIENT_TVA = 52;
    CHAMP_FICHE_CLIENT_REGIME_TVA = 53;
    CHAMP_FICHE_CLIENT_ID_TVA = 54;
    CHAMP_FICHE_CLIENT_SEUIL_TVA = 55;
    CHAMP_FICHE_CLIENT_FACT_CHANTIER = 56;
    CHAMP_FICHE_CLIENT_FACT_AGENCE = 57;
    CHAMP_FICHE_CLIENT_FACT_PAR_CHANTIER = 58;
    CHAMP_FICHE_CLIENT_FACT_PAR_AGENCE = 59;
    CHAMP_FICHE_CLIENT_FACT_SYNTH = 60;
    CHAMP_FICHE_CLIENT_BA_SYNTH = 61;
    CHAMP_FICHE_CLIENT_COMPTE_COMPTABLE = 62;
    CHAMP_FICHE_CLIENT_COMPTE_COMPTABLE_F = 63;
    CHAMP_FICHE_CLIENT_COMPTE_COLLECTIF = 64;
    CHAMP_FICHE_CLIENT_COMPTE_COLLECTIF_F = 65;
    CHAMP_FICHE_CLIENT_AXE_ANALYTHIQUE = 66;
    CHAMP_FICHE_CLIENT_RIB = 67;
    CHAMP_FICHE_CLIENT_TROP_PERCU = 68;
    CHAMP_FICHE_CLIENT_CONTACT = 69;
    CHAMP_FICHE_CLIENT_USER = 70;
    CHAMP_FICHE_CLIENT_USER2 = 71;
    CHAMP_FICHE_CLIENT_REPRESENTANT = 72;
    CHAMP_FICHE_CLIENT_TYPE_PAIEMENT = 73;
    CHAMP_FICHE_CLIENT_TYPE_PAIEMENT_ACHAT = 74;
    CHAMP_FICHE_CLIENT_FORFAIT = 75;
    CHAMP_FICHE_CLIENT_LOC = 76;
    CHAMP_FICHE_CLIENT_LOC_JOUR = 77;
    CHAMP_FICHE_CLIENT_LOC1EURO = 78;
    CHAMP_FICHE_CLIENT_LOC_IMM = 79;
    CHAMP_FICHE_CLIENT_ENCOURS_MAX = 80;
    CHAMP_FICHE_CLIENT_DELAI_PAIEMENT = 81;
    CHAMP_FICHE_CLIENT_JOUR_PAIEMENT = 82;
    CHAMP_FICHE_CLIENT_PAIEMENT_FIN_MOIS = 83;
    CHAMP_FICHE_CLIENT_DELAI_PAIEMENT_ACHAT = 84;
    CHAMP_FICHE_CLIENT_JOUR_PAIEMENT_ACHAT = 85;
    CHAMP_FICHE_CLIENT_PAIEMENT_FIN_MOIS_ACHAT = 86;
    CHAMP_FICHE_CLIENT_CODE_ECHEANCE = 87;
    CHAMP_FICHE_CLIENT_CODE_ECHEANCE_FACT = 88;
    CHAMP_FICHE_CLIENT_GROUPE = 89;
    CHAMP_FICHE_CLIENT_SOCIETE_GROUPE = 90;
    CHAMP_FICHE_CLIENT_AGENCE_EAU = 91;
    CHAMP_FICHE_CLIENT_TX_AIDE_AG_EAU = 92;
    CHAMP_FICHE_CLIENT_LIMITE_AIDE_AG_EAU = 93;
    CHAMP_FICHE_CLIENT_DEBUT_CONTRAT_AG_EAU = 94;
    CHAMP_FICHE_CLIENT_FIN_CONTRAT_AG_EAU = 95;
    CHAMP_FICHE_CLIENT_DMS = 96;
    CHAMP_FICHE_CLIENT_BSD = 97;
    CHAMP_FICHE_CLIENT_NOM_CHANTIER_BSD = 98;
    CHAMP_FICHE_CLIENT_FORFAIT_DEP = 99;
    CHAMP_FICHE_CLIENT_FRAIS_FACT = 100;
    CHAMP_FICHE_CLIENT_IMP_RECAP_FACT = 101;
    CHAMP_FICHE_CLIENT_IMP_FACT_TONNE = 102;
    CHAMP_FICHE_CLIENT_IDX_GAZOLE = 103;
    CHAMP_FICHE_CLIENT_IMP_TRAIT_FACT = 104;
    CHAMP_FICHE_CLIENT_FACT_APART = 105;
    CHAMP_FICHE_CLIENT_IMP_CERT = 106;
    CHAMP_FICHE_CLIENT_FORMAT_FACT_SPECIFIQUE = 107;
    CHAMP_FICHE_CLIENT_NBR_FACT = 108;
    CHAMP_FICHE_CLIENT_NBR_BON = 109;
    CHAMP_FICHE_CLIENT_NBR_BA = 110;
    CHAMP_FICHE_CLIENT_NOM_NEGO = 111;
    CHAMP_FICHE_CLIENT_LIB_NEGO = 112;
    CHAMP_FICHE_CLIENT_PRIX_PREST = 113;
    CHAMP_FICHE_CLIENT_FACT_AUTO = 114;
    CHAMP_FICHE_CLIENT_CAP_CHANTIER = 115;
    CHAMP_FICHE_CLIENT_VOIR_CAP = 116;
    CHAMP_FICHE_CLIENT_ESCOMPTE = 117;
    CHAMP_FICHE_CLIENT_SITE_PREST = 118;
    CHAMP_FICHE_CLIENT_SITE_CA = 119;
    CHAMP_FICHE_CLIENT_GROUPE_IMP = 120;
    CHAMP_FICHE_CLIENT_DIVERS = 121;
    CHAMP_FICHE_CLIENT_AFFACTURAGE = 122;
    CHAMP_FICHE_CLIENT_JOUR_FACTURATION = 123;
    CHAMP_FICHE_CLIENT_PRAXY = 124;
    CHAMP_FICHE_CLIENT_DEMOLISSEUR = 125;
    CHAMP_FICHE_CLIENT_FILIERE_FACT = 126;
    CHAMP_FICHE_CLIENT_LIMITE_EXUTOIRE = 127;
    CHAMP_FICHE_CLIENT_DEPLACEMENT_ECOPOL = 128;
    CHAMP_FICHE_CLIENT_PRIX_NEGO = 129;
    CHAMP_FICHE_CLIENT_LISTE_CAP = 130;
    CHAMP_FICHE_CLIENT_FACT_PARTIELLE = 131;
    CHAMP_FICHE_CLIENT_IMP_RECAP_BA = 132;
    CHAMP_FICHE_CLIENT_CHAMPS_SUPP = 133;
    CHAMP_FICHE_CLIENT_VEHICULE = 134;
    CHAMP_FICHE_CLIENT_PIECE_IDENTITE_NATURE = 135;
    CHAMP_FICHE_CLIENT_PIECE_IDENTITE_NUMERO = 136;
    CHAMP_FICHE_CLIENT_PIECE_IDENTITE_DATE_EMISSION = 137;
    CHAMP_FICHE_CLIENT_PIECE_IDENTITE_DATE_VALIDITE = 138;
    CHAMP_FICHE_CLIENT_PIECE_IDENTITE_AUTORITE = 139;
    CHAMP_FICHE_CLIENT_PROFESSION = 140;
    CHAMP_FICHE_CLIENT_LIEU_NAISSANCE = 141;
    CHAMP_FICHE_CLIENT_DATE_NAISSANCE = 142;
    CHAMP_FICHE_CLIENT_MONTANT_ANNUEL = 143;
    CHAMP_FICHE_CLIENT_PHOTO = 144;
    CHAMP_FICHE_CLIENT_EN_COMPTE = 145;
    CHAMP_FICHE_CLIENT_INFO_CHANTIER_SYNTH = 146;
    CHAMP_FICHE_CLIENT_FACT_IMMEDIAT = 147;
    CHAMP_FICHE_CLIENT_REGLEMENT = 148;
    CHAMP_FICHE_CLIENT_UNE_FACTURE_PAR_BON = 149;
    CHAMP_FICHE_CLIENT_REFACTURATION = 150;
    CHAMP_FICHE_CLIENT_REFACTURATION_ARTICLE = 151;
    CHAMP_FICHE_CLIENT_REFACTURATION_PRESTATION = 152;
    CHAMP_FICHE_CLIENT_INDICE = 153;
    CHAMP_FICHE_CLIENT_IMPORT_XML = 154;
    CHAMP_FICHE_CLIENT_DATE_MAX = 155;
    CHAMP_FICHE_CLIENT_POURCENTAGE_TPP = 156;
    CHAMP_FICHE_CLIENT_LIBELLE_TPP = 157;
    CHAMP_FICHE_CLIENT_PRENOM = 158;
    CHAMP_FICHE_CLIENT_DEP_NAISSANCE = 159;
    //Ajout ecobennes
    CHAMP_FICHE_CLIENT_NBR_BON_ECOBENNE = 160;
    //Num agrement demolisseur
    CHAMP_FICHE_CLIENT_NUM_AGREMENT_DEMOLISSEUR = 161;
    //Mandat facturation
    CHAMP_FICHE_CLIENT_MANDAT_FACTURATION = 162;
    //Date Mandat facturation
    CHAMP_FICHE_CLIENT_DATE_MANDAT_FACTURATION = 163;
    //Champ Facture par email
    CHAMP_FICHE_CLIENT_FACTURE_PAR_MAIL = 164;
    CHAMP_FICHE_CLIENT_QTE_DASRI_MOIS = 165;
    CHAMP_FICHE_CLIENT_CODE_PROFESSIONNEL = 166;
    CHAMP_FICHE_CLIENT_VOIR_FIP_DND = 167;
    CHAMP_FICHE_CLIENT_VOIR_FIP_DD = 168;
    CHAMP_FICHE_CLIENT_VOIR_CAP_DND = 169;
    CHAMP_FICHE_CLIENT_NOM = 170;
    CHAMP_FICHE_CLIENT_ENVOIE_MAIL = 171;
    CHAMP_FICHE_CLIENT_TEL_ACHAT = 172;
    CHAMP_FICHE_CLIENT_FAX_ACHAT = 173;
    CHAMP_FICHE_CLIENT_MAIL_ACHAT = 174;
    CHAMP_FICHE_CLIENT_RESP_ACHAT = 175;
    CHAMP_FICHE_CLIENT_CODE = 176;
    CHAMP_FICHE_CLIENT_TYPE_FLUX = 177;
    CHAMP_FICHE_CLIENT_NUM_BON_MANUEL_OBLIGATOIRE = 178;
    CHAMP_FICHE_CLIENT_NUM_BSD_FACTURE = 179;
    CHAMP_FICHE_CLIENT_VOLUME_APPORT_JOUR = 180;
    CHAMP_FICHE_CLIENT_ENTREPRISE_TRAVAUX = 181;
    CHAMP_FICHE_CLIENT_MAITRE_OUVRAGE = 182;
    CHAMP_FICHE_CLIENT_SITE_CA_AVOIR = 183;
    CHAMP_FICHE_CLIENT_COMPTE_COLLECTIF_DNI = 184;
    CHAMP_FICHE_CLIENT_NOM_ENVOIE = 185;
    CHAMP_FICHE_CLIENT_ADRESSE1_ENVOIE = 186;
    CHAMP_FICHE_CLIENT_ADRESSE2_ENVOIE = 187;
    CHAMP_FICHE_CLIENT_ADRESSE3_ENVOIE = 188;
    CHAMP_FICHE_CLIENT_CODE_POSTAL_ENVOIE = 189;
    CHAMP_FICHE_CLIENT_VILLE_ENVOIE = 200;
    CHAMP_FICHE_CLIENT_PAYS_ENVOIE = 201;
    CHAMP_FICHE_CLIENT_INFO_CHANTIER_FACTURE = 202;
    CHAMP_FICHE_CLIENT_NBR_IMP_BSD = 203;
    CHAMP_FICHE_CLIENT_LOGO_SOCIETE = 204;
    CHAMP_FICHE_CLIENT_HOLDING_SOCIETE_FILLE = 205;
    CHAMP_FICHE_CLIENT_NEGOCIANT = 206;
    CHAMP_FICHE_CLIENT_MAIL_BSDD = 207;
    CHAMP_FICHE_CLIENT_CHORUS = 208;
    CHAMP_FICHE_CLIENT_TGC_TVA_ACHAT = 209;
    CHAMP_FICHE_CLIENT_TGC_FRANCHISE = 210;
    CHAMP_FICHE_CLIENT_TGC_TSS = 211;
    CHAMP_FICHE_CLIENT_COMPTE_PAIEMENT = 212;
    CHAMP_FICHE_CLIENT_AXE_ANALYTHIQUE_ACHAT = 213;
    CHAMP_FICHE_CLIENT_USER_ECOGED = 214;
    CHAMP_FICHE_CLIENT_DROIT_ECOGED = 215;
    CHAMP_FICHE_CLIENT_VOLUME_APPORT_AN = 216;
    CHAMP_FICHE_CLIENT_SEUIL_COMPOSTE = 217;
    CHAMP_FICHE_CLIENT_MULTISITE = 218;
    CHAMP_FICHE_CLIENT_NBR_APPORT_JOUR = 219;
    CHAMP_FICHE_CLIENT_NBR_APPORT_SEMAINE = 220;
    CHAMP_FICHE_CLIENT_NBR_APPORT_MOIS = 221;
    CHAMP_FICHE_CLIENT_NBR_APPORT_ANNEE = 222;
    CHAMP_FICHE_CLIENT_VOLUME_APPORT_SEMAINE = 223;
    CHAMP_FICHE_CLIENT_IS_TAUX_HUMIDITE = 224;
    CHAMP_FICHE_CLIENT_IS_DECHET_5_FLUX_TRIES = 225;
    CHAMP_FICHE_CLIENT_IS_ATTESTATION_5_FLUX_TRIES = 226;
    CHAMP_FICHE_CLIENT_DOCUMENT = 227;


    public static MODULE_ECOBENNES = 1;
    /**
     * Module Ecofact
     */
    public static MODULE_ECOFACT = 2;
    /**
     * Module Ecodechet
     */
    public static MODULE_ECODECHET = 3;
    /**
     * Module Ecopol
     */
    public static MODULE_ECOPOL = 4;
    /**
     * Module Ecodd
     */
    public static MODULE_ECODD = 5;
    /**
     * Module Ecocrm
     */
    public static MODULE_ECOCRM = 6;
    /**
     * Module Ecodec
     */
    public static MODULE_ECODEC = 7;
    /**
     * Module Ecopont
     */
    public static MODULE_ECOPONT = 8;
    /**
     * Module Ecoloc*
     */
    public static MODULE_ECOLOC = 9;
    /**
     * Module Ecoachat*
     */
    public static MODULE_ECOACHAT = 10;
    /**
     * Module Ecotri*
     */
    public static MODULE_ECOTRI = 11;
    /**
     * Module EcoRH*
     */
    public static MODULE_ECORH = 12;
    /**
     * Module Ecodechetterie
     */
    public static MODULE_ECODECHETTERIE = 13;
    /**
     * Module Ecoaffaires*
     */
    public static MODULE_ECOAFFAIRES = 14;
    /**
     * Module Ecostock*
     */
    public static MODULE_ECOSTOCK = 15;
    /**
     * Module Ecobac*
     */
    public static MODULE_ECOBAC = 16;
    /*
     * Nom du Module Ecopol
     */
    public static MODULE_ECOPOL_NAME = 'Ecopol';
    /*
     * Nom du Module Ecodec
     */
    public static MODULE_ECODEC_NAME = 'Ecodec';

    public static CLIENT_PRO = 1;
    /**
     * Type de client : semi professionnel
     */
    public static CLIENT_SEMIPRO = 2;
    /**
     * Type de client : particulier
     */
    public static CLIENT_PARTICULIER = 3;
    /**
     * Type de client : contrat cadre
     */
    public static CLIENT_CADRE = 4;
    // Codes des types de zone
    /**
     * Zone : 1
     */
    public static ZONE_1 = 1;
    /**
     * Zone : 2
     */
    public static ZONE_2 = 2;
    /**
     * Zone : 3
     */
    public static ZONE_3 = 3;
    /**
     * Zone : 4
     */
    public static ZONE_4 = 4;
    /**
     * Zone : 5
     */
    public static ZONE_5 = 5;
    /**
     * Zone : 6
     */
    public static ZONE_6 = 6;

    /**
     * Logiciel de compta : AS400CSV
     */
    public static COMPTA_AS400CSV = 11;
}
